import React from "react"
import { styles } from "./style";
import { withStyles } from '@material-ui/core';
import FilterBarContainer from "./FilterBarContainer"
import { compare } from "content/utils/commonParsing"
import StyledTable from 'components/StyledTable';
import { getAttendeesPropertiesBreakdown } from "relay/event"
import Loading from "storybookComponents/Loader"
import EmptyView from "../NoPropView"
import PersonSVG from "images/Person.svg"
import { getAttendeesInviteesStatus } from "relay/event"
import { getOrgEvents } from "relay/event"
import { loadProperties } from "relay/common"
import {
  getPropertiesRows,
  csvHeadersProperties,
  getColumnsForProperties,
  csvHeadersInvitees,
  getRowsInvitees,
  getColumnsInvitees
} from "./common"

const ReportsTable = ({ classes, subOrgDetails, monthRange, setMonthRange, tabIndex, orgLevel }) => {
  const [rows, setRows] = React.useState(null);
  const [csvData, setCsvData] = React.useState([])
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [emptyView, setEmptyView] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [propertiesOfOrg, setPropertiesOfOrg] = React.useState([]);
  const [allEventsByProperties, setAllEventsByProperties] = React.useState([]);
  const [allEventsLoading, setAllEventsLoading] = React.useState(false)


  React.useEffect(() => {
    init();
  }, [])

  const init = async () => {
    try {
      setAllEventsLoading(true);
      await getAllPropertiesOfOrg();
      await getAllEventsOfOrg();
      setAllEventsLoading(false);
    } catch (err) {
      console.log("Err", err)
    }
  }

  const getAllPropertiesOfOrg = async () => {
    try {
      let response = await loadProperties(subOrgDetails.org.id)
      if (response && response.length > 0) {
        let properties = response.map((e) => {
          return {
            id: e.id,
            value: e.name
          }
        })
        setPropertiesOfOrg(properties)
      }
    } catch (err) {
      console.log("err", err)
    }
  }

  const getAllEventsOfOrg = async () => {
    try {
      let response = await getOrgEvents(subOrgDetails.org.id);
      if (response.orgHyevents && response.orgHyevents.edges) {
        let _allEvents = response.orgHyevents.edges.map(ele => ele.node);
        getDropDownValues(_allEvents);
      }
    } catch (err) {
      console.log("err", err)
    }
  }

  const getDropDownValues = (data) => {
    // let propertiesList = [];
    let eventsByProperties = [];
    let flag = true;
    data && data.map((e) => {
      let searchedEventsByID = eventsByProperties.length > 0 && eventsByProperties.find(ele => ele.id === e.propertyId);
      if (searchedEventsByID) {
        searchedEventsByID.list.push({
          id: e.id,
          value: e.title,
          startAt: e.startAt,
          endAt: e.endAt
        })
      } else {
        eventsByProperties.push({
          id: e.propertyId,
          value: e.propertyName,
          list: [{
            id: e.id,
            value: e.title,
            startAt: e.startAt,
            endAt: e.endAt
          }]
        })
      }
    })
    setAllEventsByProperties(eventsByProperties)
  }

  const setFilter = () => {
    setShowFilter(!showFilter)
  }

  const filterSelectedCallback = (properties, time, events) => {
    let eventsIds = [];
    for (var i = 0; i < events.length; i++) {
      eventsIds = [...eventsIds, ...events[i].list]
    }
    let obj = {
      orgId: subOrgDetails.org.id,
      startAt: time.startAt,
      endAt: time.endAt,
      eventIds: eventsIds,
      propertyIds: properties,
    }
    if (
      (orgLevel && tabIndex == 3 && eventsIds.length == 0) ||
      (!orgLevel && tabIndex == 2 && eventsIds.length == 0)
    ) {
      setEmptyView(true)
      return;
    } else if (orgLevel && tabIndex == 2 && properties.length == 0) {
      setEmptyView(true)
      return;
    } else {
      setEmptyView(false)
    }
    if ((orgLevel && tabIndex == 3) || (!orgLevel && tabIndex == 2)) {
      getInviteeData(eventsIds)
    } else {
      getPropertyBreakDown(obj)
    }
  }

  const handleSort = (field, order) => {
    let sortedData = data.slice().sort((a, b) => compare(a[field], b[field], !order))
    if ((orgLevel && tabIndex == 3) || (!orgLevel && tabIndex == 2)) {
      setRows(getRowsInvitees(sortedData, classes));
    } else {
      setRows(getPropertiesRows(sortedData, classes, subOrgDetails.timezoneString));
    }
    setCsvData(sortedData);
  }

  const getPropertyBreakDown = async (obj) => {
    setLoading(true)
    try {
      let response = await getAttendeesPropertiesBreakdown(obj);
      if (response.attendeesPropertiesBreakdown) {
        setRows(getPropertiesRows(response.attendeesPropertiesBreakdown, classes, subOrgDetails.timezoneString))
        setData(response.attendeesPropertiesBreakdown);
        setCsvData(response.attendeesPropertiesBreakdown)
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const getInviteeData = async (eventIds) => {
    setLoading(true)
    try {
      const response = await getAttendeesInviteesStatus(subOrgDetails.org.id, eventIds);
      if (response.attendeesInviteesStatus) {
        setRows(getRowsInvitees(response.attendeesInviteesStatus, classes))
        setCsvData(response.attendeesInviteesStatus);
        setData(response.attendeesInviteesStatus);
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }


  const handleFilterStatus = (filterValue) => {
    if (filterValue && filterValue !== "All") {
      let filteredData = data.filter(e => e.inviteeStatus === filterValue)
      setCsvData(filteredData)
      setRows(getRowsInvitees(filteredData, classes))
    } else {
      setCsvData(data)
      setRows(getRowsInvitees(data, classes))
    }
  }

  const handleFilterReason = (filterValue) => {
    if (filterValue && filterValue !== "All") {
      let filteredData = data.filter(e => e.rsvpCancelReason === filterValue)
      setCsvData(filteredData)
      setRows(getRowsInvitees(filteredData, classes))
    } else {
      setCsvData(data)
      setRows(getRowsInvitees(data, classes))
    }
  }

  const handleFilterProperty = (f) => {
    let filteredData = data.slice().filter(item => {
      return item.fullName.toLowerCase().includes(f.toLowerCase())
    })
    setRows(getRowsInvitees(filteredData, classes))
    setCsvData(filteredData)
  }


  const getMessage = () => {
    if (emptyView) {
      if (orgLevel && tabIndex == 3 && !orgLevel && tabIndex == 2) {
        return <div>Select Filters to show the invitee list.</div>
      } else {
        return <div>Select Filters to show the list.</div>
      }
    } else {
      if (orgLevel && tabIndex == 3 && !orgLevel && tabIndex == 2) {
        return <div>No invitee data for selected Event.</div>
      } else {
        return <div>No data for the selected Filters</div>
      }
    }
  }

  if (allEventsLoading) {
    return <Loading />
  }


  return (
    <div className={classes.root}>
      <FilterBarContainer propertiesOfOrg={propertiesOfOrg} allEventsByProperties={allEventsByProperties} tabIndex={tabIndex} subOrgDetails={subOrgDetails} monthRange={monthRange} setMonthRange={setMonthRange} setFetchingEvents={setLoading} filterSelectedCallback={filterSelectedCallback} csvHeaders={tabIndex == 3 ? csvHeadersInvitees : csvHeadersProperties} csvData={csvData} setFilter={tabIndex == 3 ? setFilter : null} showFilter={showFilter} orgLevel={orgLevel} />
      {
        loading ? <Loading /> : (data.length == 0 || emptyView) ? <EmptyView image={PersonSVG} message={getMessage()} /> :
          <div className={classes.tableContainer}>
            <StyledTable
              columns={(orgLevel && tabIndex == 3) || (!orgLevel && tabIndex == 2) ? getColumnsInvitees(classes, handleFilterProperty, handleFilterStatus, handleFilterReason) : (orgLevel && tabIndex == 2) || (!orgLevel && tabIndex == 1) ? getColumnsForProperties(classes).slice(1) : getColumnsForProperties(classes)}
              rows={rows}
              sortHandler={handleSort}
              showFilter={tabIndex == 3 ? showFilter : null}
              className={classes.tableContainerRoot}
            />
          </div>
      }

    </div>
  )
}

export default withStyles(styles)(ReportsTable)